import { render } from "./UserProfile.vue?vue&type=template&id=79ab2160"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=79ab2160&lang=css"
script.render = render

export default script